import { PatientSummaryData } from "fe-common/graphql";
import { useEffect, useMemo, useState } from "react";
import { usePatientCase } from "../usePatientCase";
import { useDaoContext } from "fe-web-components/diseaseview/DaoContext";
import { getFeatureFlags } from "fe-common/featureFlags/getFeatureFlags";
import { patientCaseByPresentationType } from "../updateDDToState";
import { useDiseasesSections } from "../hooks/useDiseasesSections";
import { useSuggestionsForPlan } from "../hooks/useSuggestionsForPlan";

const usePatientSummaryByCase = () => {
  const [summary, setSummary] = useState<PatientSummaryData>(null);
  const { patientCase } = usePatientCase();
  const dao = useDaoContext();

  const { featuresSections } = useDiseasesSections();
  const { findingSuggestions } = useSuggestionsForPlan();

  const diseases = useMemo(
    () => featuresSections[0].elements.map((value) => value.qf),
    [featuresSections],
  );

  const showNoOnNegates = getFeatureFlags("patientSummaryNoOnNegates");

  const discardNoForNegate = !showNoOnNegates;

  useEffect(() => {
    if (!diseases.length) return;
    (async () => {
      const summary = await dao.getPatientSummaryByCase(
        patientCaseByPresentationType(patientCase),
        diseases,
        findingSuggestions.map((s) => s.finding),
        {
          discardNoForNegate,
        },
      );
      setSummary(summary.data);
    })();
  }, [dao, discardNoForNegate, patientCase, diseases, findingSuggestions]);
  return { summary };
};

export default usePatientSummaryByCase;
